export default "__VITE_PUBLIC_ASSET__52c2c597__"